import { WebDashboardTrial, WebDashboardTrialStateType } from "@coeff/api";

export const isWebDashboardTrialExpired = (
  trial: Pick<WebDashboardTrial, "trial_state"> | null | undefined
): boolean =>
  trial?.trial_state === WebDashboardTrialStateType.TrialManualExpired ||
  trial?.trial_state === WebDashboardTrialStateType.TrialExpired ||
  trial?.trial_state === WebDashboardTrialStateType.Cancelled;
